<div class="star-rating">
<ng-container *ngFor="let star of [].constructor(stars); let i = index">
<span
     class="star"
     (click)="setRating(i + 1)"
     (mouseenter)="setHover(i + 1)"
     (mouseleave)="clearHover()"
     [style.color]="hovered > 0
                       ? (i < hovered ? 'gold' : '#D9D9D9')
                       : getColor(i)"
>
     ★
</span>
</ng-container>
</div>